import React from 'react';
import {Header} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {
    merge as _merge,
} from 'lodash';

import {createForm} from '@utils/forms';

import {EventsSimpleTable} from './EventsMultiple/EventsSimpleTable';
import EventsMultiplePresetApplyModel from '../forms/EventsMultiplePresetApplyModel';
import EventsMultiplePresetApplyForm from '../forms/EventsMultiplePresetApplyForm';

const MultipleEventPresetApplyModalContent = ({
    data,
    queryForRefetch,
    modelObjectExtension = {},
    products,
    rightsScopes,
    eventContentTypes = [],
}) => {
    const Form = createForm(
        () => (_merge(EventsMultiplePresetApplyModel(), modelObjectExtension)),
        EventsMultiplePresetApplyForm,
        {
            optionsVariables: {
                propertyLicence: data.events[0].property_licence.id,
                eventsIds: data.events.map((event) => event.id),
                products: products,
                rightsScopes,
                eventContentTypes,
            },
            queryForRefetch: queryForRefetch,
        }
    );

    return (
        <div>
            <Header content='Apply preset'/>
            <div className='ui form'>
                <EventsSimpleTable
                    events={data.events}
                />
            </div>
            <Form />
        </div>
    );
};

MultipleEventPresetApplyModalContent.propTypes = {
    data: PropTypes.object,
    queryForRefetch: PropTypes.string,
    modelObjectExtension: PropTypes.object,
    products: PropTypes.array,
    rightsScopes: PropTypes.array,
    eventContentTypes: PropTypes.array,
};

export default MultipleEventPresetApplyModalContent;
